// Models
// Utilities
import { convertPerformanceMarkerTagToString } from "../utilities/PerformanceUtilities";
/**
 * Web platform performance marker
 */ export class WebPlatformPerformanceMarker {
    mark(tag, extraData) {
        const extraDataWithTimestamp = {
            ...extraData || {},
            timestamp: Date.now().toString()
        };
        const markTag = convertPerformanceMarkerTagToString(tag, extraDataWithTimestamp);
        performance.mark(markTag);
    }
}
